import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

/**
 * DOCU-1210: letzte echte Inhaltsänderung einer Doku (audit_revision_logs) mit Revision.
 * Ohne Wert liegt die letzte Änderung vor dem Start des Revisionsprotokolls (14.10.2026);
 * dann steht der Rückfall-Text statt eines leeren Felds.
 */
@Component({
  selector: 'app-content-changed',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <ng-container *ngIf="changedAt; else beforeLog">
      {{ changedAt | date:'dd.MM.yyyy HH:mm' }}
      <span *ngIf="revision" class="text-muted text-xs">· {{ 'AUDIT_REVISION.REVISION_SHORT' | translate:{ revision: revision } }}</span>
    </ng-container>
    <ng-template #beforeLog>
      <span class="text-muted" [matTooltip]="'AUDIT_REVISION.BEFORE_LOG_TOOLTIP' | translate">
        {{ 'AUDIT_REVISION.BEFORE_LOG' | translate }}
      </span>
    </ng-template>
  `,
})
export class ContentChangedComponent {
  @Input() changedAt: string | null | undefined;
  @Input() revision: number | null | undefined;
}
